<template>
  <div class="categories">
    <div class="col l4 s12 m4" v-for="child in categories" v-bind:key="child.id">
      <category-card
        :data-content="child">
      </category-card>
    </div>
    <div class="col l4 s12 m4 hide-on-small-only" v-for="one in Array(3 - categories.length).fill(null)" v-bind:key="one">
      <div class="bordered-card">

      </div>
    </div>
    <div class="clear"></div>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import categoryCard from '@/components/categoryCard.component'
import contentService from '@/services/contentService'
export default {
  name:'categoriesComponent',
  components:{
    categoryCard
  },
  data(){
    return {
      //categories:Array,
    }
  },
  mounted(){
    this.$_fetchCategories()
  },
  computed:{
    ...mapState({
      categories:state => state.categories
    })
  },
  methods:{
    $_fetchCategories(){
      contentService.getCategoryChildren(32)
      .then(res=>{
       res.data.forEach(item=>  {
         this.$store.commit('ADD_CATEGORY', item)
       })
       // this.categories = res.data // to-computed to-vuex
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.bordered-card {
    min-height: 330px;
    border-bottom:16px;
    opacity: .5;
    border-radius:4px;
    background-image: repeating-linear-gradient(to right, grey 0%, grey 50%, transparent 50%, transparent 100%), repeating-linear-gradient(to right, grey 0%, grey 50%, transparent 50%, transparent 100%), repeating-linear-gradient(to bottom, grey 0%, grey 50%, transparent 50%, transparent 100%), repeating-linear-gradient(to bottom, grey 0%, grey 50%, transparent 50%, transparent 100%);
    background-position: left top, left bottom, left top, right top;
    background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
    background-size: 20px 1px, 20px 1px, 1px 20px, 1px 20px;
}
</style>